import { useQuery } from "@apollo/client";
import { GET_THIRD_PARTY_PAYOUTS } from "../../../features/third-party-payouts/constants";
import { ThirdPartyPayoutTable } from "../../../features/third-party-payouts/table";
import { ThirdPartyIntegratorPayout } from "../../../features/third-party-payouts/types";
import { TransferStatus } from "../../../types";
import Island from "../../../_components/Island";
import Loading from "../../../_components/Loading";
import RequestFailed from "../../../_components/RequestFailed";

export default function Page() {
  const { data, loading, error } = useQuery<{
    thirdPartyIntegratorPayouts: ThirdPartyIntegratorPayout[];
  }>(GET_THIRD_PARTY_PAYOUTS, {
    variables: {
      transferStatus: [TransferStatus.AWAITING_APPROVAL],
    },
  });

  if (loading) return <Loading />;

  if (error) return <RequestFailed />;

  return (
    <Island>
      <div className='mb-4'>
        <h2 className='text-primary-500 text-xl font-bold m-0'>
          Third Party Integrator Payout Confirmations
        </h2>
        <p className='m-0 text-primary-300'>
          Shows a list of third party integrator payouts awaiting confirmation
        </p>
      </div>

      <div>
        <ThirdPartyPayoutTable
          data={data?.thirdPartyIntegratorPayouts}
          isConfirmations
          isLoading={loading}
        />
      </div>
    </Island>
  );
}
